module.exports = __webpack_public_path__ + "assets/48412e98a033ed588accce4361277782.mp4";